"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevenueCatEnvironment = exports.RevenueCatCancelReason = exports.RevenueCatEventType = void 0;
var RevenueCatEventType;
(function (RevenueCatEventType) {
    RevenueCatEventType["initialPurchase"] = "INITIAL_PURCHASE";
    RevenueCatEventType["nonRenewingPurchase"] = "NON_RENEWING_PURCHASE";
    RevenueCatEventType["renewal"] = "RENEWAL";
    RevenueCatEventType["transfer"] = "TRANSFER";
    RevenueCatEventType["cancellation"] = "CANCELLATION";
    RevenueCatEventType["expiration"] = "EXPIRATION";
})(RevenueCatEventType = exports.RevenueCatEventType || (exports.RevenueCatEventType = {}));
var RevenueCatCancelReason;
(function (RevenueCatCancelReason) {
    RevenueCatCancelReason["developerInitiated"] = "DEVELOPER_INITIATED";
    RevenueCatCancelReason["unsubscribe"] = "UNSUBSCRIBE";
})(RevenueCatCancelReason = exports.RevenueCatCancelReason || (exports.RevenueCatCancelReason = {}));
var RevenueCatEnvironment;
(function (RevenueCatEnvironment) {
    RevenueCatEnvironment["sandbox"] = "SANDBOX";
    RevenueCatEnvironment["production"] = "PRODUCTION";
})(RevenueCatEnvironment = exports.RevenueCatEnvironment || (exports.RevenueCatEnvironment = {}));
